<template>
    <div>
        <!-- <div v-if="!dataset.some(x => x.item1.length != 0)" class="alert-no-alarms">No alarms found in current range</div> -->
        <div class="vertical" style="height:80vh; width:90vw;">
            <div class="horizontal" style="justify-content: flex-start">
                <div class="info-field horizontal" style="margin: 0 10%;">
                    <tr class="info-field-row">
<!--                        <td><p class="info-field-title">Date Range</p></td>-->
                        <td style="padding-left: 5px;" class="info-field-value">
                            <datepicker :dateFrom="dateFrom" :dateTo="dateTo" :min="dateWeekAgo" :max="new Date()" @dateChanged="dateChanged"></datepicker>
                        </td>
                    </tr>
                </div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td><p class="info-field-title">{{$t('Device')}}</p></td>
						<td><devices-select :system-id="systemId" :pre-loaded-devices="devices" :pre-selected-device="deviceObj" :date-from="dateFrom" :date-to="dateTo" @deviceChanged="(dev) => selectedDevice = dev"></devices-select></td>
                    </tr>
                </div>
            </div>
			<div class="horizontal">
				<div class="vertical alarms" >
					<div v-tippy="{ theme : 'customTheme', placement : 'left', arrow : true, allowHTML: true, content : `<div style='text-align: left;'><b>(${alarm.id}) ${$t(alarm.description)} </b></br></br> ${alarm.conditions.replaceAll('\n', '</br>')}</div>` }" v-for="alarm in [...tempAllAlarmTypes]" :key="alarm.id" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
						{{`${$t(alarm.description)}`}}
					</div>
				</div>
				<div style="width: calc(90vw - 300px); height: calc(80vh - 50px);">
					<div :id="'scichart-root-' + sid" style="width: 100%; height: 100%; margin-right: 10px; align-self: center;"></div>
				</div>
			</div>
        </div>
    </div>
</template>

<script>
import { SciChartSurface } from "scichart/Charting/Visuals/SciChartSurface";
import { NumericAxis } from "scichart/Charting/Visuals/Axis/NumericAxis";
import { EAxisAlignment } from "scichart/types/AxisAlignment";
import { FastLineRenderableSeries } from "scichart/Charting/Visuals/RenderableSeries/FastLineRenderableSeries";
import { XyDataSeries } from "scichart/Charting/Model/XyDataSeries";
import { ZoomPanModifier } from "scichart/Charting/ChartModifiers/ZoomPanModifier";
import { MouseWheelZoomModifier } from "scichart/Charting/ChartModifiers/MouseWheelZoomModifier";
import { RubberBandXyZoomModifier } from "scichart/Charting/ChartModifiers/RubberBandXyZoomModifier";
import { ZoomExtentsModifier } from "scichart/Charting/ChartModifiers/ZoomExtentsModifier";
import { chartThemeMixin } from "@/utils/chartTheme";
import { NumberRange } from "scichart/Core/NumberRange";
import { CursorModifier } from "scichart/Charting/ChartModifiers/CursorModifier";
import { EXyDirection } from "scichart/types/XyDirection";
import { ELineDrawMode } from "scichart/Charting/Drawing/WebGlRenderContext2D"
import { VerticalLineAnnotation } from "scichart/Charting/Visuals/Annotations/VerticalLineAnnotation";
import { ELabelPlacement } from "scichart/types/LabelPlacement";

import moment from 'moment'
import Datepicker from '../Datepicker.vue';

import { getDevicesForSystem } from '@api'
import { getLastWeekAlarmsForSystemPerDevice } from '../../api/api';
import DevicesSelect from "../Filters/DevicesSelect";

export default {
    mixins: [chartThemeMixin],
    props: ['sid', 'initialZoomOut', 'systemId', 'spin', 'activeSet', 'allAlarmTypes', 'deviceObj'],
    components: {
		DevicesSelect,
        Datepicker
    },
    watch: {
        selectedDevice(newVal, oldVal) {
            this.selectedDeviceIndex = this.devices.findIndex((e) => e.id == newVal.id)
            this.loadNewDataset()
        },
    },
    data() {
        var dateWeekAgoTemp = new Date();
        dateWeekAgoTemp.setDate(dateWeekAgoTemp.getDate() - 7)
        dateWeekAgoTemp = new Date(dateWeekAgoTemp.getFullYear(), dateWeekAgoTemp.getMonth(), dateWeekAgoTemp.getDate())

        return {
            sciChartSurface: null,
            wasmContext: null,
            yAxis: null,
            init: false,

            dateWeekAgo: dateWeekAgoTemp,
            dateFrom: dateWeekAgoTemp,
            dateTo: new Date(),
            data: [],
            devices: [],
            selectedDevice: {},
            selectedDeviceIndex: 0,
            dataset: [],
            alarmTypes: [],
			tempAllAlarmTypes: [...this.allAlarmTypes.sort((a,b) => a.id - b.id).reverse()],
            catalogs: ["General", "Blackbox", "Device", "Rapid24h", "Photocells", "Pressure"]
        }
    },
    methods: {
        async initSciChart() {
            const {sciChartSurface, wasmContext} = await SciChartSurface.create("scichart-root-" + this.sid);

            this.sciChartSurface = sciChartSurface;
            this.wasmContext = wasmContext;

            sciChartSurface.applyTheme(this.chartTheme())

            const xAxis = new NumericAxis(this.wasmContext, {
                axisAlignment: EAxisAlignment.Top,
                drawMajorBands: true,
                majorGridLineStyle: {
                    color: "#9D9D9D",
                },
            });

            const yAxis = new NumericAxis(this.wasmContext, { axisAlignment: EAxisAlignment.Left});
            this.yAxis = yAxis;
            yAxis.labelProvider.formatLabel = (dataValue) => parseInt(dataValue);
            yAxis.maxAutoTicks = this.allAlarmTypes.length * 2;
            yAxis.minorsPerMajor = 2
            yAxis.visibleRange = new NumberRange(0, this.allAlarmTypes.length);


            if(this.initialZoomOut == true){
                yAxis.growBy = new NumberRange(0.03, 0.03);
                xAxis.growBy = new NumberRange(0.01, 0.01);
            }

            this.sciChartSurface.xAxes.add(xAxis)
            this.sciChartSurface.yAxes.add(yAxis)

            xAxis.labelProvider.formatLabel = (dt) => {
                return moment(dt).format("DD.MM")
            }

            var alarmTypes = [...this.allAlarmTypes.sort((a,b) => a.id - b.id)]

            yAxis.labelProvider.formatLabel = (val) => {
				return alarmTypes[val] != undefined ? `${alarmTypes[val].id}` : ""
            }

            sciChartSurface.annotations.add(
              new VerticalLineAnnotation({
                      labelPlacement: ELabelPlacement.Axis,
                      showLabel: true,
                      stroke: "Red",
                      strokeThickness: 2,
                      x1: Date.now(),
                      axisLabelFill: "Red",
                      labelValue: this.$t("Now")
                  }),
            );

            await this.populateSciChart(true)

            xAxis.autoTicks = false
            xAxis.majorDelta = 86400000;
            xAxis.minorDelta = 17280000;
            let lastRange = 2;

            xAxis.visibleRangeChanged.subscribe((args) => {
                let rangeDiff = args.visibleRange.max - args.visibleRange.min;

                if (rangeDiff/3600000 <= 6 && lastRange != 0) {
                  xAxis.majorDelta = 600000;
                  xAxis.minorDelta = 120000;
                  lastRange = 0;

                  xAxis.labelProvider.formatLabel = (dt) => {
                    return moment(dt).format("DD.MM, HH:mm:ss")
                  }
                } else if ( rangeDiff/3600000 > 6 && rangeDiff / 86400000 <= 2 && lastRange != 1) {
                  xAxis.majorDelta = 3600000;
                  xAxis.minorDelta = 720000;
                  lastRange = 1;

                  xAxis.labelProvider.formatLabel = (dt) => {
                    return moment(dt).format("DD.MM, HH:mm:ss")
                  }
                } else if (rangeDiff / 86400000 > 2 && lastRange != 2) {
                  xAxis.majorDelta = 86400000;
                  xAxis.minorDelta = 17280000;
                  lastRange = 2;

                  xAxis.labelProvider.formatLabel = (dt) => {
                    return moment(dt).format("DD.MM")
                  }
                }
            });
        },
        async reloadSciChart() {
            if(this.sciChartSurface.renderableSeries != null){
                this.sciChartSurface.renderableSeries.items = [];
            }

            await this.populateSciChart(false)
        },
        async populateSciChart(init) {
            const red = "#E06C65";
            const green = "#84CA85";

            let from = new Date()
            from.setDate(from.getDate() - 7);
            from.setHours(0, 0, 0);

            let to = new Date()

            let xAlarmTypes = [...this.allAlarmTypes.sort((a,b) => a.id - b.id)]

            xAlarmTypes.forEach((at, index) => {
                const greenLineSeries = new FastLineRenderableSeries(this.wasmContext, {
                    dataSeries: new XyDataSeries(this.wasmContext, {
                        xValues: [from.getTime(), to.getTime()],
                        yValues: [index, index]
                    }),
                    stroke: green,
                    strokeThickness: 10
                })

                this.sciChartSurface.renderableSeries.add(greenLineSeries);
            })


            this.dataset.forEach(el => {
                var alarmType = el.item1;
                var alarms = el.item2;

                var value = xAlarmTypes.findIndex(at => at.id == alarmType)

                if(value == -1) {
                    return;
                }

                var filtered = alarms.sort((a, b) => new Date(b.createDate) - new Date(a.createDate))

                var alarmDates = filtered.flatMap(x => [
                    new Date(x.createDate) < from ? from.getTime() - 1 : new Date(x.createDate).getTime() - 1, 
                    new Date(x.createDate) < from ? from.getTime() : new Date(x.createDate).getTime(), 
                    new Date(x.endDate) > new Date(to) ? to.getTime() : new Date(x.endDate).getTime(), 
                    new Date(x.endDate) > new Date(to) ? to.getTime() + 1 : new Date(x.endDate).getTime() + 1]
                )
                var alarmValues = filtered.flatMap(_ => [NaN, value, value, NaN])

                const redLineSeries = new FastLineRenderableSeries(this.wasmContext, {
                    dataSeries: new XyDataSeries(this.wasmContext, {
                        xValues: alarmDates,
                        yValues: alarmValues
                    }),
                    drawNaNAs: ELineDrawMode.DiscontinuousLine,
                    stroke: red,
                    strokeThickness: 15
                })

                this.sciChartSurface.renderableSeries.add(redLineSeries);
            })

            if(init) {
                if(this.zoomBySelection == true) this.sciChartSurface.chartModifiers.add(new RubberBandXyZoomModifier({ xyDirection: EXyDirection.XDirection }));
                if(this.pan != false ) this.sciChartSurface.chartModifiers.add(new ZoomPanModifier({ xyDirection: EXyDirection.XDirection }));
                if(this.zoom != false) this.sciChartSurface.chartModifiers.add(new ZoomExtentsModifier({ xyDirection: EXyDirection.XDirection }));
                if(this.mouseZoom != false) this.sciChartSurface.chartModifiers.add(new MouseWheelZoomModifier({ xyDirection: EXyDirection.XDirection }));

                this.sciChartSurface.chartModifiers.add(new CursorModifier({
                    crosshairStroke: "#0095B2",
                    crosshairStrokeThickness: 1,
                    tooltipContainerBackground: "#000",
                    tooltipTextStroke: "#0095B2",
                    showTooltip: false,
                    axisLabelFill: "#0095B2",
                    axisLabelStroke: "#fff",
                }))
            }

            this.sciChartSurface.zoomExtents();
        },
        dateChanged(dateFrom, dateTo) {
            if(this.init == false){
                return;
            }
            this.dateFrom = dateFrom
            this.dateTo = dateTo

            this.loadNewDataset()
        },
        async loadNewDataset() {
            this.$emit('spin', true)
            this.dataset = await getLastWeekAlarmsForSystemPerDevice(this.selectedDevice.id, this.dateFrom.toISOString(), this.dateTo.toISOString())

            this.reloadSciChart()
            this.$emit('spin', false)
        },
        async getDevices() {
            this.devices = await getDevicesForSystem(this.systemId, this.dateFrom, this.dateTo)
            this.devices = this.devices.sort((a,b) => a.number - b.number)

			if(this.deviceObj !== undefined) {
				this.selectedDevice = this.devices[this.devices.findIndex(x => x.id === this.deviceObj.deviceId)]
			} else {
				this.selectedDevice = this.devices[0]
			}

            this.loadNewDataset()
        }
    },
    mounted: async function() {
        this.getDevices();
        await this.initSciChart();
        this.init = true;
    },
    beforeDestroy: async function() {
        if(this.sciChartSurface || this.wasmContext){
            this.sciChartSurface = null
            this.wasmContext = null
        }
        this.sciChartSurface = null
        this.wasmContext = null
    },
}
</script>

<style>
.tippy-popper[x-placement^=right] .tippy-tooltip.customTheme-theme .tippy-arrow {
	border-right: 8px solid #346F8B;
}
</style>

<style scoped>
.info-field-title {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;

    padding-right: 20px;
    color: #272727;
    margin: 0;
}

.info-field-row {
    width: 100%;
    margin: 0;
    padding-bottom: 5px;
}

.info-field-value {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;

    color: #272727;
}

select {
    /* border: none; */
    padding: 5px;
    width: 100%;
}

select:focus {
    outline: none;
    border-bottom: 1px solid #0095b2;
}

option {
    padding: 4px;
}

option:checked {
    background: #347C93;
    color: white;
}

.alarms {
	max-width: 300px;
	font-size: 12px;
	white-space: nowrap;
	margin-bottom: 20px;
	overflow: hidden;
	text-overflow: ellipsis;
	margin-top: 45px;
	justify-content: space-between;
	text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Charts/SciChartPerDevice.vue